/**
 * Razab Maison — Official Shopify Theme Controller (Vanilla JS)
 * High-performance, zero-dependency engine for OS 2.0
 */
/**
 * Razab Maison — Official Shopify Theme Controller (Vanilla JS)
 * High-performance, zero-dependency engine for OS 2.0
 */
(function () {
  'use strict';

  /* ==========================================================================
     1. THEME INITIALIZER & DARK MODE
     ========================================================================== */
  const ThemeManager = {
    init() {
      const toggleBtns = document.querySelectorAll('[data-theme-toggle]');
      toggleBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.toggle());
      });
    },

    toggle() {
      const isDark = document.documentElement.classList.toggle('dark');
      try {
        localStorage.setItem('razab_theme_preference', isDark ? 'dark' : 'light');
      } catch (e) {}
    }
  };

  /* ==========================================================================
     2. SCROLL REVEAL OBSERVER
     ========================================================================== */
  const ScrollReveal = {
    init() {
      const reveals = document.querySelectorAll('.reveal');
      if (!reveals.length || !('IntersectionObserver' in window)) {
        reveals.forEach((el) => el.classList.add('visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      reveals.forEach((el) => observer.observe(el));
    }
  };

  /* ==========================================================================
     3. HERO BENTO SLIDER
     ========================================================================== */
  class HeroSlider {
    constructor(element) {
      this.slider = element;
      this.slides = element.querySelectorAll('.bento-main__slide');
      this.sideSlides = element.querySelectorAll('.bento-side__slide');
      this.dots = element.querySelectorAll('.bento-dot');
      this.currentIndex = 0;
      this.autoplay = element.dataset.autoplay === 'true';
      this.intervalMs = parseInt(element.dataset.interval, 10) || 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;
      this.init();
    }

    init() {
      this.dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          this.goTo(idx);
          this.resetTimer();
        });
      });

      if (this.autoplay) {
        this.startTimer();
        this.slider.addEventListener('mouseenter', () => this.stopTimer());
        this.slider.addEventListener('mouseleave', () => this.startTimer());
      }
    }

    goTo(index) {
  if (index === this.currentIndex) return;

  this.slides[this.currentIndex]?.classList.remove('active');
  this.dots[this.currentIndex]?.classList.remove('active');

  if (this.sideSlides.length) {
    this.sideSlides.forEach((slide) => {
      slide.classList.remove('active');
    });
  }

  this.currentIndex = (index + this.slides.length) % this.slides.length;

  this.slides[this.currentIndex]?.classList.add('active');
  this.dots[this.currentIndex]?.classList.add('active');

  if (this.sideSlides.length) {
    const sideIndex = this.currentIndex % this.sideSlides.length;
    this.sideSlides[sideIndex]?.classList.add('active');
  }
}

    next() {
      this.goTo(this.currentIndex + 1);
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.next(), this.intervalMs);
    }

    stopTimer() {
      if (this.timer) clearInterval(this.timer);
    }

    resetTimer() {
      if (this.autoplay) {
        this.stopTimer();
        this.startTimer();
      }
    }
  }

  /* ==========================================================================
     4. FEATURED CAROUSEL RAIL CONTROLLER
     ========================================================================== */
  class FeaturedCarousel {
    constructor(element) {
      this.container = element;
      this.rail = element.querySelector('[data-carousel-rail]');
      this.prevBtn = element.querySelector('[data-carousel-prev]');
      this.nextBtn = element.querySelector('[data-carousel-next]');

      if (!this.rail) return;
      this.init();
    }

    init() {
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll(-1));
        this.nextBtn.addEventListener('click', () => this.scroll(1));
        this.rail.addEventListener('scroll', () => this.updateButtonState(), { passive: true });
        this.updateButtonState();
      }
    }

    scroll(direction) {
      const cardWidth = this.rail.firstElementChild ? this.rail.firstElementChild.offsetWidth + 24 : 300;
      this.rail.scrollBy({ left: direction * cardWidth * 1.5, behavior: 'smooth' });
    }

    updateButtonState() {
      if (!this.prevBtn || !this.nextBtn) return;
      const atStart = this.rail.scrollLeft <= 5;
      const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 5;

      this.prevBtn.disabled = atStart;
      this.nextBtn.disabled = atEnd;
    }
  }

  /* ==========================================================================
     5. MOBILE NAVIGATION MENU
     ========================================================================== */
  const MobileNav = {
    init() {
      const toggle = document.querySelector('[data-mobile-menu-toggle]');
      const menu = document.querySelector('[data-mobile-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', () => {
        const isOpen = menu.classList.toggle('is-open');
        toggle.classList.toggle('is-active', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      document.addEventListener('click', (e) => {
        if (!toggle.contains(e.target) && !menu.contains(e.target) && menu.classList.contains('is-open')) {
          menu.classList.remove('is-open');
          toggle.classList.remove('is-active');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  };

  /* ==========================================================================
     6. SHOPIFY AJAX CART & DRAWER CONTROLLER
     ========================================================================== */
  const CartDrawer = {
    init() {
      /*
        FIX: this theme renders its drawer from snippets/cart-drawer.liquid as
        #CartDrawer with a [data-overlay-for="CartDrawer"] backdrop. The old
        ids below never existed, so this.drawer was always null and open()
        only set body overflow, which is why Add to cart appeared to do
        nothing outside the homepage. Fall back to the old ids if present.
      */
      this.drawer = document.getElementById('CartDrawer') || document.getElementById('cart-drawer');
      this.backdrop = document.querySelector('[data-overlay-for="CartDrawer"]') || document.getElementById('cart-backdrop');
      this.closeBtns = document.querySelectorAll('[data-close-cart]');
      this.openBtns = document.querySelectorAll('[data-open-cart]');
      this.shippingThreshold = (window.ShopifyTheme && window.ShopifyTheme.freeShippingThreshold) || 5000;

      this.bindEvents();
      this.refresh();
    },

    bindEvents() {
      this.openBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      // Intercept Quick Add forms / buttons
      document.addEventListener('click', (e) => {
        const atcBtn = e.target.closest('[data-quick-add]');
        if (atcBtn) {
          e.preventDefault();
          const variantId = atcBtn.dataset.variantId;
          if (variantId) {
            this.addItem(variantId, 1, atcBtn);
          }
        }
      });
    },

    open() {
      if (this.drawer) {
        this.drawer.classList.add('is-open', 'open', 'active');
        this.drawer.setAttribute('data-open', 'true');
        this.drawer.setAttribute('aria-hidden', 'false');
      }
      if (this.backdrop) {
        this.backdrop.classList.add('is-active', 'is-open', 'open', 'active');
        this.backdrop.setAttribute('data-open', 'true');
        this.backdrop.setAttribute('aria-hidden', 'false');
      }
      document.documentElement.classList.add('rz-cart-drawer-open');
      document.body.classList.add('rz-cart-drawer-open');
      /*
        FIX: do NOT set an inline body overflow here. cart-drawer.liquid already
        locks scrolling via html.rz-cart-drawer-open, and closing the drawer with
        its own X button is handled by cart-drawer.js, which only removes that
        class. An inline style set here would survive that close and keep
        overflow:hidden on <body>, which permanently breaks position:sticky on
        the header and the collection filter rail.
      */
    },

    close() {
      if (this.drawer) {
        this.drawer.classList.remove('is-open', 'open', 'active');
        this.drawer.setAttribute('data-open', 'false');
        this.drawer.setAttribute('aria-hidden', 'true');
      }
      if (this.backdrop) {
        this.backdrop.classList.remove('is-active', 'is-open', 'open', 'active');
        this.backdrop.setAttribute('data-open', 'false');
        this.backdrop.setAttribute('aria-hidden', 'true');
      }
      document.documentElement.classList.remove('rz-cart-drawer-open');
      document.body.classList.remove('rz-cart-drawer-open');
      /* Clear any legacy inline lock left behind by older code paths. */
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    },

    async refresh() {
      /* cart-drawer.js re-renders the drawer's own markup; use it when there. */
      if (window.Razab && typeof window.Razab.refreshCart === 'function') {
        try { await window.Razab.refreshCart(); } catch (e) { /* fall through */ }
      }

      try {
        const res = await fetch(`${window.ShopifyTheme?.cartUrl || '/cart'}.js`);
        if (!res.ok) return;
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.warn('Cart refresh failed:', err);
      }
    },

    async addItem(variantId, quantity = 1, buttonElement = null) {
      const originalText = buttonElement ? buttonElement.innerHTML : '';
      if (buttonElement) {
        buttonElement.disabled = true;
        buttonElement.innerHTML = '<span>Adding...</span>';
      }

      try {
        const res = await fetch(`${window.ShopifyTheme?.cartAddUrl || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });

        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.description || 'Could not add item');
        }

        await this.refresh();
        this.open();
      } catch (err) {
        alert(err.message || 'Item could not be added to bag.');
      } finally {
        if (buttonElement) {
          buttonElement.disabled = false;
          buttonElement.innerHTML = originalText;
        }
      }
    },

    async updateQuantity(key, quantity) {
      try {
        const res = await fetch(`${window.ShopifyTheme?.cartChangeUrl || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });

        if (!res.ok) throw new Error('Quantity update failed');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error(err);
      }
    },

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return `$${(cents / 100).toFixed(2)}`;
    },

    render(cart) {
      // Update global header count badge
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Free shipping calculation
      const remainingCents = Math.max(0, this.shippingThreshold - cart.total_price);
      const percent = Math.min(100, Math.round((cart.total_price / this.shippingThreshold) * 100));

      const shippingFill = document.getElementById('cart-shipping-fill');
      const shippingText = document.getElementById('cart-shipping-text');
      if (shippingFill) shippingFill.style.width = `${percent}%`;
      if (shippingText) {
        if (remainingCents === 0 && cart.item_count > 0) {
          shippingText.innerHTML = `<span>✨ You unlocked <strong>Complimentary Express Delivery!</strong></span>`;
        } else {
          shippingText.innerHTML = `<span>Spend <strong>${this.formatMoney(remainingCents)}</strong> more for <strong>Free Express Delivery</strong></span>`;
        }
      }

      // Render items
      const body = document.getElementById('cart-drawer-body');
      const footer = document.getElementById('cart-drawer-footer');
      const subtotalEl = document.getElementById('cart-subtotal');
      const totalEl = document.getElementById('cart-total-price');

      if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = this.formatMoney(cart.total_price);

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div class="cart-drawer__empty">
            <h4 class="cart-drawer__empty-title">Your Culinary Bag is Empty</h4>
            <p class="cart-drawer__empty-desc">Discover our heirloom borosilicate containers and elevated cookware.</p>
            <button type="button" class="btn-clean-redeem" onclick="window.RazabCart.close()">Continue Shopping</button>
          </div>
        `;
        if (footer) footer.style.display = 'none';
        return;
      }

      if (footer) footer.style.display = 'block';

      let itemsHtml = '';
      cart.items.forEach((item) => {
        itemsHtml += `
          <div class="cart-item" data-line-key="${item.key}">
            <img src="${item.featured_image?.url || item.image || ''}" alt="${item.title}" class="cart-item__image">
            <div class="cart-item__details">
              <h4 class="cart-item__title">${item.product_title}</h4>
              ${item.variant_title ? `<span class="cart-item__variant">${item.variant_title}</span>` : ''}
              <div class="cart-item__actions">
                <div class="cart-item__qty">
                  <button type="button" class="cart-item__qty-btn" onclick="window.RazabCart.updateQuantity('${item.key}', ${item.quantity - 1})" aria-label="Decrease quantity">−</button>
                  <span class="cart-item__qty-val">${item.quantity}</span>
                  <button type="button" class="cart-item__qty-btn" onclick="window.RazabCart.updateQuantity('${item.key}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
                </div>
                <div class="cart-item__price">${this.formatMoney(item.final_line_price)}</div>
                <button type="button" class="cart-item__remove" onclick="window.RazabCart.updateQuantity('${item.key}', 0)">Remove</button>
              </div>
            </div>
          </div>
        `;
      });

      body.innerHTML = itemsHtml;
    }
  };

  /* ==========================================================================
     7. PANTRY POINTS & LOYALTY CONTROLLER
     ========================================================================== */
  const LoyaltyWidget = {
    init() {
      this.fab = document.getElementById('razab-rewards-fab');
      this.drawer = document.getElementById('razab-rewards-drawer');
      this.bubble = document.getElementById('rewards-tooltip-bubble');
      this.points = 1250;

      this.bindEvents();
    },

    bindEvents() {
      if (this.bubble) {
        this.bubble.addEventListener('click', () => this.open());
      }
    },

    dismissBubble() {
      if (this.bubble) this.bubble.style.display = 'none';
    },

    open() {
      if (this.drawer) this.drawer.classList.add('is-open');
      this.dismissBubble();
    },

    close() {
      if (this.drawer) this.drawer.classList.remove('is-open');
    },

    toggle() {
      if (this.drawer) this.drawer.classList.toggle('is-open');
    },

    claimVoucher(cost, title) {
      if (this.points < cost) {
        alert(`You need ${cost} points for ${title}. Current balance: ${this.points} pts.`);
        return;
      }
      this.points -= cost;
      this.updateBalance();
      alert(`🎉 Voucher redeemed: "${title}". Copied discount code to clipboard!`);
    },

    earnPoints(amount, reason) {
      this.points += amount;
      this.updateBalance();
      alert(`✨ +${amount} Points Earned for ${reason}! Current balance: ${this.points.toLocaleString()} Pts.`);
    },

    copyInvite() {
      const input = document.getElementById('referral-input');
      if (input) {
        navigator.clipboard.writeText(input.value);
        const btnText = document.getElementById('btn-copy-ref-text');
        if (btnText) {
          btnText.textContent = 'Copied!';
          setTimeout(() => (btnText.textContent = 'Copy Link'), 2500);
        }
      }
    },

    updateBalance() {
      const valEl = document.getElementById('user-points-val');
      if (valEl) valEl.textContent = this.points.toLocaleString();
    }
  };

  /* ==========================================================================
     8. GLOBAL EXPORTS & INITIALIZATION
     ========================================================================== */
  /*
    FIX: assets/cart-drawer.js already publishes a fully working cart API on
    window.RazabCart (open/close/refresh/refreshAndOpen/add/change). theme.js
    loads after it, so this line used to overwrite that API with the object
    above, breaking every caller. Only claim the name if nothing set it.
  */
  if (!window.RazabCart || typeof window.RazabCart.add !== 'function') {
    window.RazabCart = CartDrawer;
  }
  window.RazabQuickAdd = CartDrawer;
  window.RazabLoyalty = LoyaltyWidget;
  window.RazabTheme = {
    ThemeManager,
    ScrollReveal,
    HeroSlider,
    FeaturedCarousel
  };

  document.addEventListener('DOMContentLoaded', () => {
    ThemeManager.init();
    ScrollReveal.init();
    MobileNav.init();
    CartDrawer.init();
    LoyaltyWidget.init();

    // Initialize Bento Hero Sliders
    document.querySelectorAll('[data-hero-slider]').forEach((el) => new HeroSlider(el));

    // Initialize Featured Carousels
    document.querySelectorAll('[data-featured-carousel]').forEach((el) => new FeaturedCarousel(el));
  });
})();



/* ==========================================================================
   INTERACTIVE TRANSITIONS & UTILITIES (MERGED FOR SHOPIFY OS 2.0)
   ========================================================================== */
/**
 * Razab Maison - Ultra-Luxury Cinematic Page Transitions & Account Flow
 * Creates silky smooth liquid-glass transitions between pages, account portal, and shop collections.
 */
(function () {
  'use strict';

  // Inject Page Transition Veil into DOM
  function initTransitionVeil() {
    if (document.getElementById('page-transition-veil')) return;

    const veil = document.createElement('div');
    veil.id = 'page-transition-veil';
    veil.className = 'page-transition-veil';
    veil.innerHTML = `
      <div class="veil-content">
        <div class="veil-logo">
          <div class="veil-mark">R</div>
          <span class="veil-text">Razab</span>
        </div>
        <div class="veil-status" id="veil-status">CULINARY MAISON</div>
        <div class="veil-shimmer-bar">
          <div class="veil-shimmer-progress"></div>
        </div>
      </div>
    `;
    document.body.appendChild(veil);

    // Fade out veil on initial page load
    window.addEventListener('pageshow', () => {
      veil.classList.remove('active');
      veil.classList.add('fade-out');
      setTimeout(() => {
        veil.classList.remove('fade-out');
      }, 500);
    });
  }

  // Smooth Transition to Destination
  function transitionTo(url, statusText = 'CULINARY MAISON') {
    const veil = document.getElementById('page-transition-veil');
    const statusEl = document.getElementById('veil-status');
    if (!veil) {
      window.location.href = url;
      return;
    }

    if (statusEl) statusEl.textContent = statusText;

    veil.classList.remove('fade-out');
    veil.classList.add('active');

    setTimeout(() => {
      window.location.href = url;
    }, 380);
  }

  // Attach Listeners to Account Icons and Page Links
  function initLinks() {
    initTransitionVeil();

    function isCurrentPage(target) {
      const path = window.location.pathname;
      const targetClean = target.replace('.html', '').replace(/^\//, '');
      const pathClean = path.replace('.html', '').replace(/^\//, '');
      if (targetClean === 'index' && (pathClean === '' || pathClean === 'index')) return true;
      return pathClean === targetClean;
    }

    document.addEventListener('click', (e) => {
      // Allow browser shortcuts (new tab, etc.)
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return;

      // Account Button Click
      const accountBtn = e.target.closest('#nav-account, a[href="account.html"], .mobile-account-link');
      if (accountBtn) {
        if (isCurrentPage('account.html')) return;
        e.preventDefault();
        accountBtn.classList.add('icon-pulse-active');
        transitionTo('account.html', 'OPENING COLLECTOR PORTAL');
        return;
      }

      // Glass Storage Link
      const shopBtn = e.target.closest('a[href="glass-storage.html"]');
      if (shopBtn) {
        if (isCurrentPage('glass-storage.html')) return;
        e.preventDefault();
        shopBtn.classList.add('icon-pulse-active');
        transitionTo('glass-storage.html', 'ENTERING GLASS COLLECTION');
        return;
      }

      // Fit Finder Link
      const fitBtn = e.target.closest('a[href="fit-finder.html"]');
      if (fitBtn) {
        if (isCurrentPage('fit-finder.html')) return;
        e.preventDefault();
        fitBtn.classList.add('icon-pulse-active');
        transitionTo('fit-finder.html', 'FIND YOUR PERFECT FIT');
        return;
      }

      // Business Prices Link
      const bizBtn = e.target.closest('a[href="business.html"]');
      if (bizBtn) {
        if (isCurrentPage('business.html')) return;
        e.preventDefault();
        bizBtn.classList.add('icon-pulse-active');
        transitionTo('business.html', 'COMMERCIAL & WHOLESALE');
        return;
      }

      // Blog Link
      const blogBtn = e.target.closest('a[href="blog.html"]');
      if (blogBtn) {
        if (isCurrentPage('blog.html')) return;
        e.preventDefault();
        blogBtn.classList.add('icon-pulse-active');
        transitionTo('blog.html', 'THE CULINARY JOURNAL');
        return;
      }

      // Home Link
      const homeBtn = e.target.closest('a[href="index.html"], #nav-logo');
      if (homeBtn) {
        if (isCurrentPage('index.html')) return;
        e.preventDefault();
        transitionTo('index.html', 'RETURNING TO MAISON');
        return;
      }
    });
  }

  // 3D Magnetic Parallax Tilt on Bento Cards
  function initHeroParallax() {
    const bentoMain = document.getElementById('bento-main');
    const bentoSide = document.getElementById('bento-side');
    if (!bentoMain || !bentoSide) return;

    [bentoMain, bentoSide].forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const rotateX = ((y - centerY) / centerY) * -3.5;
        const rotateY = ((x - centerX) / centerX) * 3.5;

        card.style.transform = `perspective(1200px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) translateY(-4px)`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) translateY(0)';
      });
    });
  }

  // ══════════════════════════════════════════════
  // SHOPPABLE INSTAGRAM REEL CONTROLLER
  // ══════════════════════════════════════════════
  const REEL_DATA = {
    1: {
      reelImg: 'images/insta-reel-1.jpg',
      igLink: 'https://www.instagram.com/reel/DSqSkQQD0VN/',
      caption: '“Making him breakfast on Christmas with Razab glass containers...”',
      productId: 'rz-reel-01',
      productTitle: 'Razab 24-Piece Borosilicate Glass Storage Set',
      productDesc: 'Pure borosilicate glass with sage green airtight silicone locking lids. 100% leak-proof, microwave, freezer, and oven-safe up to 750°F.',
      price: 39.99,
      origPrice: 54.99,
      save: 15.00,
      saveTag: 'SAVE 27%',
      rating: '4.9 (2,450+ Reviews)',
      image: 'images/product-glass-storage.jpg',
      specs: 'Borosilicate Glass · Sage Green Lids',
      badge: 'BEST SELLER',
      perks: [
        '✓ Airtight Silicone Locking Lids',
        '✓ -40°F to 750°F Thermal Shock Safe',
        '✓ 100% BPA-Free Pure Glass'
      ]
    },
    2: {
      reelImg: 'images/insta-reel-2.jpg',
      igLink: 'https://www.instagram.com/reel/DR3tssAAD3r/',
      caption: '“Homemade lasagna from scratch, cheesy & hearty with Razab containers...”',
      productId: 'rz-reel-02',
      productTitle: 'Razab 30-Piece Glass Meal Prep & Casserole Set',
      productDesc: 'Heavy-duty meal prep containers with deep-dish casserole glass and easy-snap airtight freshness lids.',
      price: 44.99,
      origPrice: 59.99,
      save: 15.00,
      saveTag: 'SAVE 25%',
      rating: '5.0 (1,890+ Reviews)',
      image: 'images/product-meal-prep.jpg',
      specs: 'Heavy-Duty Glass · Locking Seal',
      badge: 'TOP REVIEWED',
      perks: [
        '✓ Deep-Dish Baking & Meal Prep',
        '✓ Leak-Proof Silicone Seal',
        '✓ Stackable Space-Saving Design'
      ]
    },
    3: {
      reelImg: 'images/insta-reel-3.jpg',
      igLink: 'https://www.instagram.com/reel/Db4Qz9lgX1n/',
      caption: '“2 egg yolks + 1 whole egg... Artisan baking prep in Razab glass bowls.”',
      productId: 'rz-reel-03',
      productTitle: 'Razab 18-Piece Round & Mixing Glass Storage Set',
      productDesc: 'Multi-sized round glass mixing and storage bowls with flexible airtight seal lids for effortless baking & prep.',
      price: 34.99,
      origPrice: 48.00,
      save: 13.01,
      saveTag: 'SAVE 27%',
      rating: '4.9 (1,230+ Reviews)',
      image: 'images/category-glass.jpg',
      specs: 'Round Borosilicate · Mixing Set',
      badge: 'CHEF FAVORITE',
      perks: [
        '✓ Multi-Capacity Mixing & Storage',
        '✓ Non-Porous Stain Resistant Glass',
        '✓ Dishwasher & Freezer Safe'
      ]
    }
  };

  let activeReelId = 1;
  let activeReelQty = 1;

  window.openShoppableReel = function(reelId) {
    const data = REEL_DATA[reelId] || REEL_DATA[1];
    activeReelId = reelId;
    activeReelQty = 1;

    const modal = document.getElementById('insta-reel-modal');
    if (!modal) return;

    // Populate Left Side (Reel)
    const reelImg = document.getElementById('modal-reel-img');
    const igLink = document.getElementById('modal-ig-link');
    const reelCaption = document.getElementById('modal-reel-caption');

    if (reelImg) reelImg.src = data.reelImg;
    if (igLink) igLink.href = data.igLink;
    if (reelCaption) reelCaption.textContent = data.caption;

    // Populate Right Side (Product)
    const prodImg = document.getElementById('modal-prod-img');
    const prodBadge = document.getElementById('modal-prod-badge');
    const prodRating = document.getElementById('modal-prod-rating');
    const prodTitle = document.getElementById('modal-prod-title');
    const prodDesc = document.getElementById('modal-prod-desc');
    const prodPrice = document.getElementById('modal-prod-price');
    const prodOrig = document.getElementById('modal-prod-orig');
    const prodSave = document.getElementById('modal-prod-save');
    const prodPerks = document.getElementById('modal-prod-perks');
    const qtySpan = document.getElementById('reel-modal-qty');
    const addBtn = document.getElementById('btn-modal-add-cart');

    if (prodImg) prodImg.src = data.image;
    if (prodBadge) prodBadge.textContent = data.badge;
    if (prodRating) prodRating.textContent = data.rating;
    if (prodTitle) prodTitle.textContent = data.productTitle;
    if (prodDesc) prodDesc.textContent = data.productDesc;
    if (prodPrice) prodPrice.textContent = `$${data.price.toFixed(2)}`;
    if (prodOrig) prodOrig.textContent = `$${data.origPrice.toFixed(2)}`;
    if (prodSave) prodSave.textContent = data.saveTag;
    if (qtySpan) qtySpan.textContent = '1';
    if (addBtn) {
      addBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <span>Add to Cart</span>
      `;
      addBtn.style.background = '#465236';
      addBtn.disabled = false;
    }

    if (prodPerks && data.perks) {
      prodPerks.innerHTML = data.perks.map(p => `<span class="perk-pill">${p}</span>`).join('');
    }

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  window.closeShoppableReel = function() {
    const modal = document.getElementById('insta-reel-modal');
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };

  window.changeReelQty = function(delta) {
    activeReelQty = Math.max(1, Math.min(20, activeReelQty + delta));
    const qtySpan = document.getElementById('reel-modal-qty');
    if (qtySpan) qtySpan.textContent = activeReelQty;
  };

  window.addReelProductToCart = function() {
    const data = REEL_DATA[activeReelId] || REEL_DATA[1];
    if (window.RazabCart) {
      window.RazabCart.add({
        id: data.productId,
        name: data.productTitle,
        price: data.price,
        origPrice: data.origPrice,
        save: data.save,
        image: data.image,
        specs: data.specs,
        quantity: activeReelQty
      });
      const addBtn = document.getElementById('btn-modal-add-cart');
      if (addBtn) {
        addBtn.innerHTML = `<span>✓ Added to Cart!</span>`;
        addBtn.style.background = '#2e7d32';
      }
      setTimeout(() => {
        window.closeShoppableReel();
        window.RazabCart.open();
      }, 400);
    }
  };

  // ══════════════════════════════════════════════
  // CULINARY JOURNAL CONTROLLER
  // ══════════════════════════════════════════════
  window.openJournalStory = function(storyId) {
    if (storyId === 1) {
      if (typeof window.openShoppableReel === 'function') {
        window.openShoppableReel(1);
      }
    } else if (storyId === 2) {
      if (typeof window.openShoppableReel === 'function') {
        window.openShoppableReel(2);
      }
    } else {
      if (typeof window.openShoppableReel === 'function') {
        window.openShoppableReel(3);
      }
    }
  };

  window.playJournalAudio = function() {
    const btn = document.querySelector('.journal-btn-play');
    if (btn) {
      btn.style.background = '#c56950';
      btn.style.color = '#fff';
      setTimeout(() => {
        alert('🎧 Playing Audio Essay: "Quietly Crafting — The Philosophy of Pure Glass & Mindful Cooking"');
        btn.style.background = '#ffffff';
        btn.style.color = '#1c1a16';
      }, 300);
    }
  };

  // ══════════════════════════════════════════════
  // LOYALTY & REWARDS CONTROLLER
  // ══════════════════════════════════════════════
  let userPoints = 1250;

  window.toggleRewardsDrawer = function() {
    const drawer = document.getElementById('razab-rewards-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('active')) {
      window.closeRewardsDrawer();
    } else {
      window.openRewardsDrawer();
    }
  };

  window.openRewardsDrawer = function() {
    const drawer = document.getElementById('razab-rewards-drawer');
    if (!drawer) return;
    drawer.classList.add('active');
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  };

  window.closeRewardsDrawer = function() {
    const drawer = document.getElementById('razab-rewards-drawer');
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  window.switchRewardsTab = function(tabId) {
    const drawer = document.getElementById('razab-rewards-drawer');
    if (!drawer) return;

    // Update Tab Buttons
    drawer.querySelectorAll('.rewards-tab-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });

    // Update Tab Panes
    drawer.querySelectorAll('.rewards-tab-pane').forEach(pane => {
      pane.classList.toggle('active', pane.id === `pane-${tabId}`);
    });
  };

  window.claimVoucher = function(cost, voucherName) {
    if (userPoints < cost) {
      alert(`Insufficient Points. You need ${cost} points for ${voucherName}.`);
      return;
    }
    userPoints -= cost;
    updatePointsDisplay();

    alert(`🎉 Voucher Claimed! Your code for "${voucherName}" is RAZAB-${Math.random().toString(36).substring(2, 7).toUpperCase()}. Added to checkout automatically!`);
  };

  window.earnSocialPoints = function(points, reason) {
    userPoints += points;
    updatePointsDisplay();
    alert(`✨ +${points} Points Awarded for ${reason}! New Balance: ${userPoints.toLocaleString()} Pts.`);
  };

  function updatePointsDisplay() {
    const ptsEl = document.getElementById('user-points-val');
    const fabPts = document.querySelector('.rewards-fab__pts');
    if (ptsEl) ptsEl.textContent = userPoints.toLocaleString();
    if (fabPts) fabPts.textContent = `${userPoints.toLocaleString()} Pts`;
  }

  window.copyReferralLink = function() {
    const input = document.getElementById('referral-input');
    const btnText = document.getElementById('btn-copy-ref-text');
    if (input) {
      input.select();
      input.setSelectionRange(0, 99999);
      try {
        navigator.clipboard.writeText(input.value);
      } catch (e) {
        document.execCommand('copy');
      }
      if (btnText) {
        btnText.textContent = '✓ Copied!';
        setTimeout(() => {
          btnText.textContent = 'Copy Link';
        }, 2000);
      }
    }
  };

  // ══════════════════════════════════════════════
  // REWARDS TOOLTIP PROMPT CONTROLLER
  // ══════════════════════════════════════════════
  window.initRewardsTooltip = function() {
    const bubble = document.getElementById('rewards-tooltip-bubble');
    if (!bubble) return;

    // Pop up automatically after 1.5s on page visit / refresh
    setTimeout(() => {
      if (!bubble.classList.contains('dismissed')) {
        bubble.classList.add('visible');
      }
    }, 1500);
  };

  window.dismissRewardsTooltip = function() {
    const bubble = document.getElementById('rewards-tooltip-bubble');
    if (bubble) {
      bubble.classList.remove('visible');
      bubble.classList.add('dismissed');
    }
  };

  window.openRewardsFromTooltip = function() {
    window.dismissRewardsTooltip();
    window.openRewardsDrawer();
  };

  // ══════════════════════════════════════════════
  // GLOBAL MOBILE DRAWER & NAVBAR CONTROLLER
  // ══════════════════════════════════════════════
  function initMobileMenu() {
    const hamburger = document.getElementById('nav-hamburger');
    const mobileMenu = document.getElementById('mobile-menu');
    if (!hamburger || !mobileMenu) return;
    if (hamburger.dataset.menuBound === 'true') return;
    hamburger.dataset.menuBound = 'true';

    // Move menu to document.body to break out of any header/navbar backdrop-filter stacking contexts
    if (mobileMenu.parentElement !== document.body) {
      document.body.appendChild(mobileMenu);
    }

    let overlay = document.getElementById('nav-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'nav-overlay';
      overlay.className = 'navbar__overlay';
      document.body.appendChild(overlay);
    } else if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    // Add luxury close button inside drawer if not present
    if (!mobileMenu.querySelector('.mobile-menu__close')) {
      const closeBtn = document.createElement('button');
      closeBtn.className = 'mobile-menu__close';
      closeBtn.setAttribute('type', 'button');
      closeBtn.setAttribute('aria-label', 'Close menu');
      closeBtn.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      `;
      closeBtn.addEventListener('click', closeMenu);
      mobileMenu.insertBefore(closeBtn, mobileMenu.firstChild);
    }

    function toggleMenu(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const willOpen = !mobileMenu.classList.contains('open');
      if (willOpen) {
        openMenu();
      } else {
        closeMenu();
      }
    }

    function openMenu() {
      mobileMenu.classList.add('open');
      hamburger.classList.add('active');
      overlay.classList.add('active');
      document.documentElement.classList.add('nav-menu-open');
      document.body.classList.add('nav-menu-open');
    }

    function closeMenu() {
      mobileMenu.classList.remove('open');
      hamburger.classList.remove('active');
      overlay.classList.remove('active');
      document.documentElement.classList.remove('nav-menu-open');
      document.body.classList.remove('nav-menu-open');
    }

    hamburger.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }

  // Close modals/drawers on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      window.closeShoppableReel();
      window.closeRewardsDrawer();
      const mobileMenu = document.getElementById('mobile-menu');
      const hamburger = document.getElementById('nav-hamburger');
      const overlay = document.getElementById('nav-overlay');
      if (mobileMenu) mobileMenu.classList.remove('open');
      if (hamburger) hamburger.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.documentElement.classList.remove('nav-menu-open');
      document.body.classList.remove('nav-menu-open');
    }
  });

  // Global Export
  window.RazabTransitions = {
    goTo: transitionTo
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initLinks();
      initHeroParallax();
      initRewardsTooltip();
      initMobileMenu();
    });
  } else {
    initLinks();
    initHeroParallax();
    initRewardsTooltip();
    initMobileMenu();
  }
})();



/* ==========================================================================
   GLASS STORAGE & CATALOG FILTER ENGINE
   ========================================================================== */
/**
 * Razab — Glass Storage Catalog Controller
 * Exact port of features/export/react/components/store/product-card.tsx
 */

(function () {
  'use strict';

  // 1. Exact 18 Products from features/export/react/data/products.ts
  const PRODUCTS = [
    {
      handle: "1860-ml-glass",
      title: "1860ML Glass Set — Set of 2",
      price: 43.99,
      compareAt: 49.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1860ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1860ml-glass-687223.webp?v=1773088867",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1860ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1860ml-glass-515157.webp?v=1773088867"
      ],
      rating: 4.9,
      reviews: 253,
      volumeMl: 1860,
      pieces: 2,
      lidColor: "clear",
      badge: "BEST SELLER",
      nestSavingPct: 37,
      sharesLid: 1,
      blurb: "Our signature two-piece set — deep enough for a full roast chicken, shallow enough to stack."
    },
    {
      handle: "1860ml-glass-set-with-color-lids-set-of-2-pc",
      title: "1860ML Glass Set with Color Lids — Set of 2",
      price: 43.99,
      compareAt: 49.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/1860ml-glass-set-with-color-lids-set-of-2-pc-2-1860ml-glass-black-ll-2393378.jpg?v=1773123615",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/1860ml-glass-set-with-color-lids-set-of-2-pc-2-1860ml-glass-black-ll-6974664.jpg?v=1773123553"
      ],
      rating: 4.9,
      reviews: 45,
      volumeMl: 1860,
      pieces: 2,
      lidColor: "color",
      badge: "NEW",
      nestSavingPct: 37,
      sharesLid: 1,
      blurb: "The same borosilicate body, finished with colour-coded locking lids so leftovers never get lost."
    },
    {
      handle: "6500-ml-large-food-storage-container",
      title: "6500ML Extra Large Container with Locking Lid & Handle",
      price: 42.99,
      compareAt: 51.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/6500ml-extra-large-glass-container-with-locking-lid-and-handle-6500ml-clear-6691168.jpg?v=1773289275",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/6500ml-extra-large-glass-container-with-locking-lid-and-handle-6500ml-clear-9494225.jpg?v=1773289274"
      ],
      rating: 4.8,
      reviews: 118,
      volumeMl: 6500,
      pieces: 1,
      lidColor: "clear",
      badge: "CUSTOMER FAVORITE",
      nestSavingPct: 0,
      sharesLid: 1,
      blurb: "Batch-cook territory. A moulded handle and four-point lock make it easy to carry, oven to fridge."
    },
    {
      handle: "6500ml-extra-large-glass-container-with-color-locking-lid-and-handle",
      title: "6500ML Extra Large Container with Color Locking Lid",
      price: 29.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/6500ml-extra-large-glass-container-with-color-locking-lid-and-handle-6500ml-black-ll-4660087.png?v=1773206953",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/6500ml-extra-large-glass-container-with-color-locking-lid-and-handle-6500ml-black-ll-4837495.png?v=1773206952"
      ],
      rating: 4.7,
      reviews: 62,
      volumeMl: 6500,
      pieces: 1,
      lidColor: "color",
      nestSavingPct: 0,
      sharesLid: 1,
      blurb: "Extra-large capacity with a matte colour lid that hides fingerprints on a busy countertop."
    },
    {
      handle: "2260-ml-glass",
      title: "2260ML Glass Set — Set of 2",
      price: 42.99,
      compareAt: 47.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/2260-glass-set-set-of-2-pc-glass-food-storage-container-441831.jpg?v=1747049274",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/2260-glass-set-set-of-2-pc-glass-food-storage-container-178081.webp?v=1747049274"
      ],
      rating: 4.8,
      reviews: 96,
      volumeMl: 2260,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 37,
      sharesLid: 1,
      blurb: "The everyday pair — lasagne, salads, marinades. Straight walls scrape clean with one pass."
    },
    {
      handle: "3300-ml-glass-set",
      title: "3300ML Glass Container Set",
      price: 33.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/3300ml-glass-contianer-set-3300ml-glassnew-903520.jpg?v=1747049291",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/3300ml-glass-contianer-set-3300ml-glassnew-322987.webp?v=1747049291"
      ],
      rating: 4.7,
      reviews: 74,
      volumeMl: 3300,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 40,
      sharesLid: 1,
      blurb: "A generous mid-size set for family portions and weekend prep."
    },
    {
      handle: "4800-ml-glass-container-with-locking-lid",
      title: "4800ML Large Container with Airtight Locking Lid",
      price: 39.99,
      compareAt: 51.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/4800-ml-large-glass-food-storage-container-with-airtight-locking-lid-4800-glass-937310.jpg?v=1747049220",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/4800-ml-large-glass-food-storage-container-with-airtight-locking-lid-4800-glass-567921.jpg?v=1747049220"
      ],
      rating: 4.8,
      reviews: 141,
      volumeMl: 4800,
      pieces: 1,
      lidColor: "clear",
      badge: "BEST SELLER",
      nestSavingPct: 0,
      sharesLid: 0,
      blurb: "Silicone-gasket lid holds a true seal — carry soup without a single drip."
    },
    {
      handle: "3900ml-large-glass-food-storage-container-with-airtight-lid",
      title: "3900ML Large Container with Airtight Lid",
      price: 29.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/3900ml-large-glass-food-storage-container-with-airtight-lid-520353.jpg?v=1748141363",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/3900ml-large-glass-food-storage-container-with-airtight-lid-527391.jpg?v=1748141362"
      ],
      rating: 4.6,
      reviews: 53,
      volumeMl: 3900,
      pieces: 1,
      lidColor: "clear",
      nestSavingPct: 0,
      sharesLid: 1,
      blurb: "Tall sides, small footprint — fits a fridge shelf without stealing the whole row."
    },
    {
      handle: "1520-ml-glass-set",
      title: "1520ML Glass Set — Set of 2",
      price: 33.99,
      compareAt: 43.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1520ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1520ml-102786.webp?v=1747049294",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1520ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1520ml-305504.webp?v=1747049294"
      ],
      rating: 4.7,
      reviews: 88,
      volumeMl: 1520,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 35,
      sharesLid: 1,
      blurb: "Lunch-sized and stackable, with a lid that doubles as a serving tray."
    },
    {
      handle: "10-glass-old-lisa",
      title: "10 Pc Glass Container Set — 5 Containers, 5 Lids",
      price: 31.99,
      compareAt: 45.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/10-pc-glass-container-set-5-containers-and-5-lids-10-glassfood-set-807390.webp?v=1747049261",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/10-pc-glass-container-set-5-contianers-and-5-lids-948793.webp?v=1747049261"
      ],
      rating: 4.8,
      reviews: 204,
      volumeMl: 5000,
      pieces: 10,
      lidColor: "clear",
      nestSavingPct: 55,
      sharesLid: 0,
      blurb: "A complete starter kitchen in one box — five nesting sizes, five matched lids."
    },
    {
      handle: "razab-2700-ml-container-with-vent-lid",
      title: "2700ML Large Container with Vent Lid",
      price: 28.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/razabs-2700-ml-large-glass-food-storage-container-with-vent-2700ml-vent-660248.jpg?v=1747049217",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/razabs-2700-ml-large-glass-food-storage-container-with-vent-2700ml-vent-473769.jpg?v=1747049217"
      ],
      rating: 4.6,
      reviews: 39,
      volumeMl: 2700,
      pieces: 1,
      lidColor: "clear",
      nestSavingPct: 0,
      sharesLid: 1,
      blurb: "A built-in steam vent means microwave reheating without lifting the lid."
    },
    {
      handle: "6-pc-glass",
      title: "6 Pc Glass Container Set — 3 Sizes",
      price: 33.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/6-pc-glass-containers-set-3-unique-sizes-352899.jpg?v=1747049271",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/6-pc-glass-containers-set-3-unique-sizes-293369.jpg?v=1747049271"
      ],
      rating: 4.7,
      reviews: 67,
      volumeMl: 3000,
      pieces: 6,
      lidColor: "clear",
      nestSavingPct: 45,
      sharesLid: 0,
      blurb: "Three sizes, three lids — the shortest path from leftovers to lunch."
    },
    {
      handle: "razab-10-pc-glass-food-containers-set",
      title: "Razab 10 Pc Glass Food Container Set",
      price: 31.99,
      compareAt: 45.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/razab-10-pc-glass-food-containers-set-10-glassnew-436988.jpg?v=1747049214",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/files/razab-10-pc-glass-food-containers-set-10-glassnew-514502.jpg?v=1747049214"
      ],
      rating: 4.8,
      reviews: 176,
      volumeMl: 5000,
      pieces: 10,
      lidColor: "clear",
      nestSavingPct: 55,
      sharesLid: 0,
      blurb: "The gifting set — ten pieces that nest down to a single shelf."
    },
    {
      handle: "10-glass-new-lisa-color-lids",
      title: "Set of 10 Pc — Colour-Coded Lids",
      price: 39.99,
      compareAt: 44.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/set-of-10-pc-glass-food-storage-container-color-coded-lids-10-glass-colorlids-1-454711.jpg?v=1747049258",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/set-of-10-pc-glass-food-storage-container-color-coded-lids-10-glass-colorlids-1-230397.jpg?v=1747049259"
      ],
      rating: 4.9,
      reviews: 132,
      volumeMl: 5000,
      pieces: 10,
      lidColor: "color",
      badge: "CUSTOMER FAVORITE",
      nestSavingPct: 55,
      sharesLid: 0,
      blurb: "Colour-code by day, by person, or by meal. The tidiest fridge you have had."
    },
    {
      handle: "1200-ml-glass-set",
      title: "1200ML Glass Set — Set of 2",
      price: 28.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1200ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1200ml-glass-481243.webp?v=1747049279",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1200ml-glass-set-set-of-2-pc-glass-food-storage-container-2-1200ml-glass-226891.webp?v=1747049280"
      ],
      rating: 4.7,
      reviews: 91,
      volumeMl: 1200,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 35,
      sharesLid: 1,
      blurb: "Perfect single-serve pair for desk lunches and overnight oats."
    },
    {
      handle: "2700-ml-glass-set",
      title: "2700ML Glass Container Set",
      price: 28.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/2700ml-glass-container-set-342570.webp?v=1747049288",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/2700ml-glass-container-set-275356.jpg?v=1747049288"
      ],
      rating: 4.6,
      reviews: 48,
      volumeMl: 2700,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 38,
      sharesLid: 1,
      blurb: "A dependable mid-size set for casseroles, curries and cut fruit."
    },
    {
      handle: "set-of-1520-and-2700-ml-glass-container",
      title: "1520ML + 2700ML — Set of 2",
      price: 34.99,
      compareAt: 39.99,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1500ml-and-2700ml-set-of-2-glass-food-storage-container-razab-xl-l-con-168039.jpg?v=1747049304",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/1500ml-and-2700ml-set-of-2-glass-food-storage-container-razab-xl-l-con-989051.jpg?v=1747049304"
      ],
      rating: 4.8,
      reviews: 57,
      volumeMl: 2700,
      pieces: 2,
      lidColor: "clear",
      nestSavingPct: 36,
      sharesLid: 1,
      blurb: "One large, one extra-large — the pairing most customers end up buying twice."
    },
    {
      handle: "4-pc-round-colored-lids",
      title: "4 Pc Round — 2 Sets of Coloured Lids",
      price: 9.00,
      compareAt: 13.00,
      available: true,
      images: [
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/4-pc-round-glass-food-storage-contianers-2-sets-of-colored-lids-746367.webp?v=1747049253",
        "https://cdn.shopify.com/s/files/1/0648/7018/7256/products/4-pc-round-glass-food-storage-contianers-2-sets-of-colored-lids-898181.webp?v=1747049254"
      ],
      rating: 4.5,
      reviews: 26,
      volumeMl: 600,
      pieces: 4,
      lidColor: "color",
      nestSavingPct: 0,
      sharesLid: 0,
      blurb: "Small rounds for sauces, dips and spice blends."
    }
  ];

  // 2. Filter State
  const filterState = {
    availability: 'all', // 'all', 'in-stock', 'on-sale'
    lidColor: 'all',     // 'all', 'color'
    maxPrice: 100,
    sortBy: 'featured'
  };

  // 3. Filter & Sort Logic
  function getFilteredProducts() {
    return PRODUCTS.filter(p => {
      if (filterState.availability === 'in-stock' && !p.available) return false;
      if (filterState.availability === 'on-sale' && !p.compareAt) return false;
      if (filterState.lidColor === 'color' && p.lidColor !== 'color') return false;
      if (p.price > filterState.maxPrice) return false;
      return true;
    });
  }

  function getSortedProducts(list) {
    const sorted = [...list];
    switch (filterState.sortBy) {
      case 'price-low':
        sorted.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        sorted.sort((a, b) => b.price - a.price);
        break;
      case 'rating':
        sorted.sort((a, b) => b.rating - a.rating || b.reviews - a.reviews);
        break;
      case 'bestseller':
        sorted.sort((a, b) => b.reviews - a.reviews);
        break;
      case 'featured':
      default:
        break;
    }
    return sorted;
  }

  // 4. Render Stars HTML
  function renderStars(rating, reviews) {
    const rounded = Math.round(rating);
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      const fillClass = i <= rounded ? 'star-filled' : 'star-empty';
      starsHtml += `<svg class="star-icon ${fillClass}" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
    }
    return `
      <div class="card-stars-row">
        <div class="stars-icons">${starsHtml}</div>
        <span class="stars-label">${rating.toFixed(1)} (${reviews})</span>
      </div>
    `;
  }

  // 5. Render Grid (Exact React Structure)
  function renderCatalogGrid() {
    const gridEl = document.getElementById('shop-grid');
    const countEl = document.getElementById('shop-product-count');
    const emptyEl = document.getElementById('shop-empty-state');
    if (!gridEl) return;

    const filtered = getFilteredProducts();
    const sorted = getSortedProducts(filtered);

    if (countEl) {
      countEl.textContent = `${sorted.length} products`;
    }

    if (sorted.length === 0) {
      gridEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    } else {
      gridEl.style.display = 'grid';
      if (emptyEl) emptyEl.style.display = 'none';
    }

    gridEl.innerHTML = sorted.map(product => {
      const onSale = product.compareAt && product.compareAt > product.price;
      const badge = product.badge || (onSale ? "SALE" : null);
      const hoverImg = product.images[1] || product.images[0];
      const lidLabel = product.lidColor === 'color' ? 'colour lids' : 'clear lids';

      return `
        <article class="react-product-card" data-handle="${product.handle}">
          
          <!-- Image Box with hover swap & quick add -->
          <div class="react-card__media">
            <div class="react-card__img-wrap">
              <img src="${product.images[0]}" alt="${product.title}" class="react-card__img react-card__img--main" loading="lazy">
              <img src="${hoverImg}" alt="${product.title} angle" class="react-card__img react-card__img--hover" loading="lazy">
            </div>

            ${badge ? `<span class="react-card__badge ${onSale && !product.badge ? 'badge--sale' : ''}">${badge}</span>` : ''}
            ${!product.available ? `<span class="react-card__soldout">Sold out</span>` : ''}

            ${product.available ? `
              <button type="button" class="react-card__quick-add" onclick="quickAddProduct('${product.handle}', event)">
                Quick Add +
              </button>
            ` : ''}
          </div>

          <!-- Card Content Body -->
          <div class="react-card__body">
            
            ${renderStars(product.rating, product.reviews)}

            <h3 class="react-card__title">
              <a href="javascript:void(0)">${product.title}</a>
            </h3>

            <p class="react-card__subtitle">
              ${product.volumeMl.toLocaleString()} ml · ${product.pieces} pc · ${lidLabel}
            </p>

            <div class="react-card__specs-pills">
              ${product.pieces > 1 && product.nestSavingPct > 0 ? `
                <span class="spec-pill spec-pill--nest">Nests ${product.nestSavingPct}% smaller</span>
              ` : ''}
              ${product.sharesLid > 0 ? `
                <span class="spec-pill spec-pill--lid">Lid fits ${product.sharesLid} more</span>
              ` : ''}
            </div>

            <div class="react-card__price-row">
              ${onSale ? `<span class="price-compare">$${product.compareAt.toFixed(2)}</span>` : ''}
              <span class="price-main">$${product.price.toFixed(2)}</span>
            </div>

            <button type="button" class="react-card__btn-atc" onclick="quickAddProduct('${product.handle}', event)">
              ${product.available ? 'Add to cart' : 'Notify me'}
            </button>

          </div>

        </article>
      `;
    }).join('');
  }

  // 6. Global Filter Handlers
  window.filterSidebarAvailability = function (val) {
    filterState.availability = (filterState.availability === val) ? 'all' : val;
    renderCatalogGrid();
  };

  window.filterSidebarLids = function (val) {
    filterState.lidColor = (filterState.lidColor === val) ? 'all' : val;
    renderCatalogGrid();
  };

  window.filterSidebarMaxPrice = function (val) {
    filterState.maxPrice = parseFloat(val);
    const displayEl = document.getElementById('catalog-price-val');
    if (displayEl) displayEl.textContent = `$${parseFloat(val).toFixed(2)}`;
    renderCatalogGrid();
  };

  window.quickAddProduct = function (handle, evt) {
    const product = PRODUCTS.find(p => p.handle === handle);
    if (!product || !window.RazabCart) return;

    let originEl = null;
    if (evt) {
      const btn = evt.currentTarget || evt.target;
      if (btn) {
        const card = btn.closest('.react-product-card') || btn.closest('article') || btn.closest('.react-card');
        originEl = card ? (card.querySelector('.react-card__img--main') || card.querySelector('img') || btn) : btn;
      }
    }

    window.RazabCart.add({
      id: product.handle,
      name: product.title,
      price: product.price,
      origPrice: product.compareAt || product.price,
      save: product.compareAt ? product.compareAt - product.price : 0,
      image: product.images[0],
      specs: `${product.volumeMl}ML · Borosilicate Glass`,
      quantity: 1
    }, originEl);
  };

  // 7. Initialize
  document.addEventListener('DOMContentLoaded', () => {
    const sortSelect = document.getElementById('select-sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => {
        filterState.sortBy = e.target.value;
        renderCatalogGrid();
      });
    }

    const resetBtn = document.getElementById('btn-empty-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        filterState.availability = 'all';
        filterState.lidColor = 'all';
        filterState.maxPrice = 100;
        filterState.sortBy = 'featured';

        document.querySelectorAll('.catalog-sidebar input[type="radio"]').forEach(r => r.checked = false);
        const slider = document.getElementById('catalog-price-slider');
        if (slider) slider.value = 100;
        const displayEl = document.getElementById('catalog-price-val');
        if (displayEl) displayEl.textContent = '$100.00';

        renderCatalogGrid();
      });
    }

    renderCatalogGrid();
  });

})();


/* RAZAB HOMEPAGE CUSTOMIZER REINITIALIZATION
   Runs only when Shopify Theme Editor reloads a section.
   Front-end behavior remains unchanged. */
document.addEventListener('shopify:section:load', function(event) {
  var root = event.target;
  if (!root) return;

  root.querySelectorAll('.reveal').forEach(function(el) {
    el.classList.add('visible');
  });

  if (window.RazabTheme && window.RazabTheme.HeroSlider) {
    root.querySelectorAll('[data-hero-slider]').forEach(function(el) {
      new window.RazabTheme.HeroSlider(el);
    });
  }
});
